// extracted by mini-css-extract-plugin
export default {"link":"styles_link__OI7Ar","checkbox-wrapper":"styles_checkbox-wrapper__6clB6","checkbox":"styles_checkbox__Mv5TV"};